import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server} from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class ClientContractProfileService {

  constructor(private http:HttpClient) { }
  createManyForAClientContract(clientContractId,postData){
    return this.http.post<any[]>(`${server}clientcontractprofiles/clientcontract/${clientContractId}`,postData);
  }
  findAllForAClientContract(clientContractId){
    return this.http.get<any[]>(`${server}clientcontractprofiles/clientcontract/${clientContractId}`);
  }
  findAllWithoutFileUploadForAClientContract(clientContractId){
    return this.http.get<any[]>(`${server}clientcontractprofiles/clientcontract/${clientContractId}`);
  }  
  deleteAllForAClientContract(clientContractId){
    return this.http.delete(`${server}clientcontractprofiles/clientcontract/${clientContractId}`);
  }   
  getClientContractProfileDetails(profile){
    return this.http.get<any>(`${server}cdecase/getcdecaseprofiledetails/${profile}`);
  }
  getAuthorizationform(){
    return this.http.get<any>(`${server}getAuthorizationConsentForm/`);
  }
}
